import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordNav } from './buffers';
import { setRoute } from './context';

/**
 * Capture des NAVIGATIONS : à chaque changement de route, publie la route courante
 * (normalisée) dans le contexte et pousse une miette `nav`.
 *
 * Normalisation : les segments porteurs de contenu potentiel sont réduits à un
 * gabarit (`/u/:slot`) — aucun titre/nom d'utilisateur ne fuite via l'URL. Monté
 * sous le routeur, ne rend rien.
 */

/** Réduit un chemin concret à son gabarit stable (pas de contenu utilisateur). */
export function normalizeRoute(pathname: string): string {
  return (
    pathname
      // Anciens liens legacy `/u/:slot/*`.
      .replace(/^\/u\/[^/]+(?=\/|$).*/, '/u/:slot')
  );
}

export function RouteBreadcrumbs(): null {
  const { pathname } = useLocation();
  useEffect(() => {
    const normalized = normalizeRoute(pathname);
    setRoute(normalized);
    recordNav(normalized);
  }, [pathname]);
  return null;
}
